import React, { useEffect, useContext, useState, useRef } from "react";
import { toast } from "react-toastify";
import {
  sd_btn_loading,
  SD_Right_Arrow_white,
} from "../../../Assets/imageList";

import { SD_Context } from "../../../context/sd-context";
import "../../../Utils/sd-styles/sd-css/main.css";
import "react-toastify/dist/ReactToastify.css";
import Sd_loading from "../../../Components/sd-common-components/sd-loading";
import { withRouter } from "react-router";
import ParokshaSevaService from "../../../services/sd-parokshaseva.service";
import Sd_DashboardService from "../../../services/sd-dashboard.service";
import PhoneInput from "react-phone-input-2";

const Sd_dashboard_quick_booking_donations = ({ history }) => {
  const {
    setActive,
    setActivePath,
    currentQuickBookingDonation,
    setCurrentQuickBookingDonation,
    userData,
    logout,
  } = useContext(SD_Context);
  //-------------------------------------------------------------states--------------------------------------------------------//

  const [mobile, setMobile] = useState("91");
  const supportedLanguages = ["en-in", "jp-in", "de-in", "es-in"];
  const [loading, setloading] = useState(true);
  const [selectedLanguage, setSelectedlanguage] = React.useState("en-in");
  const ref = useRef(null);
  const [err, setErr] = useState([]);
  const [donation, setDonation] = useState(null);
  const [amount, setAmount] = useState("");
  const templeID = process.env.REACT_APP_TEMPLE ?? "SSVVSD";

  //-------------------------------------------------------------states--------------------------------------------------------//

  //-------------------------------------------------------------useeffect--------------------------------------------------------//

  useEffect(() => {
    setActive("quick-booking-donations");
    setActivePath("Quick-Booking-Donations");
    let path = new URLSearchParams(history?.location?.search).get("state");
    if (path === "clear") {
      setCurrentQuickBookingDonation(null);
    }
    if (
      supportedLanguages.includes(
        history?.location?.pathname?.split?.("/")?.[1]
      )
    ) {
      setSelectedlanguage(history?.location?.pathname?.split?.("/")?.[1]);
    } else {
      setSelectedlanguage("en-in");
    }
    getData();
  }, []);

  //-------------------------------------------------------------useeffect--------------------------------------------------------//

  //-------------------------------------------------------------functions--------------------------------------------------------//

  const getData = async () => {
    try {
      let res = await Sd_DashboardService.donations_getall(templeID);

      // Auto-select e-Hundi donation
      const eHundiDonation = res?.find(
        (item) => item?.name?.toLowerCase() === "e-hundi"
      );
      if (eHundiDonation) {
        setDonation(eHundiDonation);
      }

      if (currentQuickBookingDonation) {
        setDonation(currentQuickBookingDonation?.donation);
        setAmount(currentQuickBookingDonation?.amount);
        setMobile(currentQuickBookingDonation?.mobile);
      } else {
        // Auto-fill mobile number from userData
        if (userData?.phone) {
          const phoneNumber = userData.phone.replace("+", "");
          setMobile(phoneNumber || "91");
        }
      }
      setloading(false);
    } catch (e) {
      toast.warning(e.message);
      if (e.message === "Session Expired") {
        logout();

        history?.push(
          `/${selectedLanguage}/devotee/signin?to=devotee-app/quick-booking/donations?state=clear`
        );
      }
      setloading(false);
    }
  };

  const handleSubmit = async () => {
    setloading(true);
    let a = true;

    if (a) {
      let data = [...err];

      // Only validate mobile number
      if (mobile.substring(0, 2) === "91") {
        if (mobile.length !== 12) {
          data.push({ type: "phone", msg: "Invalid mobile number" });
        }
      } else {
        if (mobile.length < 8) {
          data.push({ type: "phone", msg: "Invalid mobile number" });
        }
      }

      // Only validate donation type
      if (donation === "" || donation?.length === 0 || !donation) {
        data.push({ type: "type", msg: "Select a donation type" });
      }

      // Only validate amount
      if (amount === "") {
        data.push({ type: "amount", msg: "Please enter a donation amount" });
      } else {
        if (donation && amount < donation?.min_amount) {
          data.push({
            type: "amount",
            msg: `Minimum donation amount is ${donation?.min_amount}`,
          });
        }
      }

      setErr(data);
      if (data.length !== 0) {
        setloading(false);
        ref.current?.scrollIntoView({
          behavior: "smooth",
          block: "start",
        });
        return;
      }
    }

    try {
      // Use user's name from userData or default
      const donorName = userData?.name || userData?.firstName || "Donor";

      let dto = {
        donationId: Number(donation?.id),
        devoteeName: donorName,
        amount: Number(amount),
        contact: `+${mobile}`,
        address: "",
        city: "",
        state: "",
        country: "India",
        pinCode: 0,
      };

      let subDataObj = {
        cartContains: ["donation"],
        donationBookings: [dto],
        returnPriceStats: true,
      };

      let res = await ParokshaSevaService.bookings(subDataObj, templeID);

      if (res) {
        let data = {
          donation,
          amount,
          mobile,
          res,
        };
        setCurrentQuickBookingDonation(data);
        setloading(false);

        history?.push(
          `/${selectedLanguage}/devotee-app/quick-booking/donations/confirm`
        );
      }
    } catch (e) {
      ref.current?.scrollIntoView({
        behavior: "smooth",
        block: "start",
      });

      toast.error(e.message);
      if (e.message === "Session Expired") {
        logout();

        history?.push(
          `/${selectedLanguage}/devotee/signin?to=devotee-app/quick-booking/donations`
        );
      }
      setloading(false);
      ref.current?.scrollIntoView({
        behavior: "smooth",
        block: "start",
      });

      return;
    }
  };

  //-------------------------------------------------------------functions--------------------------------------------------------//

  return (
    <div
      className="col-xs-12 col-sm-12 col-md-9 col-lg-9 sd-dashboard"
      style={{
        minHeight: document.getElementById("side-menu")?.offsetHeight,
      }}
    >
      {!loading ? (
        <div className="sd-profile sd-seva-form">
          <h2 className="sd-side-heading fw400">
            <span className="fw700" ref={ref}>
              Donations{" "}
            </span>
            Quick Booking
          </h2>

          <div className="clearfix">
            <form className="sd-form">
              <div className="clearfix">
                <div className="form-group col-xs-12 col-sm-12 col-md-6 col-lg-6  xssm-pl-0 xssm-pr-0  pr-0">
                  <label>
                    Amount<span className="sd-imp">*</span>
                  </label>
                  <input
                    type="number"
                    maxLength="6"
                    onWheel={(event) => event.currentTarget.blur()}
                    className={
                      err?.find((e) => e.type === `amount`)
                        ? "form-control sd-red"
                        : amount !== ""
                        ? "form-control sd-voilet"
                        : "form-control"
                    }
                    style={{ textTransform: "none" }}
                    placeholder={`Minimum donation amount Rs. ${
                      donation?.price !== undefined ? donation?.price : ""
                    }`}
                    value={amount}
                    onChange={(e) => {
                      if (err.find((e) => e.type === "amount")) {
                        let data = err.filter((e) => e.type !== "amount");
                        setErr(data);
                      }
                      setAmount(e.target.value);
                    }}
                  />

                  <p className="d-EM mr-15">
                    {err.find((e) => e.type === "amount")?.msg}
                  </p>
                </div>
                <div className="form-group col-xs-12 col-sm-12 col-md-6 col-lg-6  xssm-pr-0 pl-0">
                  <label>
                    Mobile Number<span className="sd-imp">*</span>
                  </label>
                  <div className={"sd-profile-mobile"}>
                    <PhoneInput
                      inputExtraProps={{
                        autoFocus: true,
                        enableSearch: true,
                        countryCodeEditable: false,
                      }}
                      onlyCountries={["in"]}
                      placeholder="Enter Your 10 digit mobile number"
                      maxLength="15"
                      countryCodeEditable={false}
                      containerClass={
                        err?.find((e) => e.type === "phone")
                          ? "sd-phone-voilet sd-red"
                          : mobile !== ""
                          ? "sd-phone-voilet"
                          : ""
                      }
                      country="in"
                      value={mobile}
                      onChange={(e) => {
                        if (
                          err?.find(
                            (e) => e.type === "phone" || e.type === "common"
                          )
                        ) {
                          let array = err.filter((e) => {
                            if (e.type !== "phone" && e.type !== "common") {
                              return e;
                            }
                          });
                          setErr(array);
                        }
                        setMobile(e);
                      }}
                    />
                    <p className="d-EM ">
                      {err.find((e) => e.type === "phone")
                        ? err.find((e) => e.type === "phone")?.msg
                        : ""}
                    </p>
                  </div>
                </div>
              </div>
              <hr className="clearfix"></hr>
              <div className="clearfix mt-50">
                <a
                  className="sd-btn-orange"
                  onClick={() => {
                    if (!loading) {
                      handleSubmit();
                    }
                  }}
                >
                  Confirm Booking{" "}
                  {loading ? (
                    <img
                      src={sd_btn_loading}
                      alt=".."
                      className="sd-arrow-btn ml-5 h-20"
                    />
                  ) : (
                    <img
                      className="sd-arrow-btn ml-5"
                      src={SD_Right_Arrow_white}
                    />
                  )}
                </a>
              </div>
            </form>
          </div>
        </div>
      ) : (
        <Sd_loading />
      )}
    </div>
  );
};
export default withRouter(Sd_dashboard_quick_booking_donations);
